<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-dialog
      :visible="showDialog"
      style="padding-top: 0"
      class="package-box"
      :before-close="onCloseDialog"
      :close-on-click-modal="false"
    >
      <div class="work-title">
        <h3 style="margin: 0">
          工单：{{ work_id }}
          <span
            v-if="is_son_order"
            style="color: #f00; background-color: yellow"
            >(子工单)</span
          >
        </h3>
      </div>
      <div class="header-box">拆包信息</div>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="寄回运单号：">
          <el-input
            v-model="work.back_shipping_num"
            size="mini"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称:">
          {{ work.goods_name }}
        </el-form-item>
        <el-form-item label="商品图片：">
          <div style="width: 50px; height: 50px">
            <img
              style="height: 100%; width: 100%"
              :src="work.main_img"
              @click="imgClick(work.middle_img)"
            />
          </div>
        </el-form-item>
        <el-form-item label="用户上传图片：" style="margin-top: 10px">
          <div style="width: 50px; height: 50px">
            <img
              v-viewer
              style="height: 100%; width: 100%"
              :src="work.picture"
            />
          </div>
        </el-form-item>
        <el-form-item label="颜色-尺码：">
          <div>{{ work.co_val + "-" + work.si_val }}</div>
        </el-form-item>
        <el-form-item label="问题类型:">
          <el-select v-model="model.id" size="small" @change="problemChange">
            <el-option :value="0" label="全部"></el-option>
            <el-option
              v-for="item in problem"
              :key="item.problem_id"
              :value="item.problem_id"
              :label="item.problem_name"
            ></el-option>
          </el-select>
          <el-select v-model="model.sub_id" size="small">
            <el-option :value="0" label="全部"></el-option>
            <el-option
              v-for="item in subPorblem"
              :key="item.problem_id"
              :value="item.problem_id"
              :label="item.problem_name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="待拆包件数：">
          <div>{{ work.num }}</div>
        </el-form-item>
        <el-form-item label="登记类型：">
          <el-select
            v-if="blp_type.length > 0"
            v-model="value"
            placeholder="请选择"
            size="mini"
          >
            <el-option label="正常" :value="0"></el-option>
            <el-option
              v-for="item in blp_type"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
          <i
            class="el-icon-plus"
            style="
              margin-left: 10px;
              height: 40px;
              width: 40px;
              cursor: pointer;
            "
            @click="addBlp"
          />
          <el-table :data="data" style="width: 80%">
            <el-table-column prop="blp_type_index" label="类型">
              <template slot-scope="scope">
                <div class="blp-text">
                  {{ getBlpText(scope.row.blp_type) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="数量" width="150">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.num"
                  :min="min"
                  :max="Number(work.num)"
                  size="mini"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="blp_note" label="备注" width="150">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.blp_note"
                  size="mini"
                  placeholder="请输入内容"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="blp-img-up" label="图片">
              <template slot-scope="scope">
                <div v-if="!scope.row.blp_img" @click="setIndex(scope.$index)">
                  <el-upload
                    class="“upload”"
                    :action="action"
                    :on-success="handleSuccess"
                    with-credentials
                  >
                    <i class="el-icon-picture" style="font-size: 20px" />
                  </el-upload>
                </div>
                <img
                  v-if="scope.row.blp_img"
                  v-viewer
                  :src="scope.row.blp_img"
                  class="avatar"
                  style="width: 30px; height: 30px"
                />
              </template>
            </el-table-column>
            <el-table-column label="删除">
              <template slot-scope="scope">
                <div class="blp-op">
                  <i
                    class="el-icon-delete"
                    style="margin-left: 10px; font-size: 20px"
                    @click="deleteItem(scope.$index)"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <!-- 收件人信息 -->
      <div v-if="work.handle_type == 1">
        <div class="header-box">
          收件人信息<span style="font-size: 14px; color: red"
            >（如不填写，默认为原订单收件人地址）</span
          >
        </div>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="寄出地址：">
            <el-select
              v-model="form.province"
              size="mini"
              placeholder="省"
              style="width: 100px"
              @change="getCity"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option
                v-for="item in province"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="form.city"
              size="mini"
              placeholder="市"
              style="width: 100px"
              @change="getDistrict"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option
                v-for="item in city"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="form.district"
              size="mini"
              placeholder="区/县"
              style="width: 100px"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option
                v-for="item in district"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="form.address"
              placeholder="地址"
              size="mini"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人姓名：">
            <el-input
              v-model="form.consignee"
              placeholder="收件人姓名"
              size="mini"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人电话：">
            <el-input
              v-model="form.mobile"
              placeholder="收件人电话"
              size="mini"
              style="width: 400px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitData">确 定</el-button>
      </span>
    </el-dialog>
    <preview-image
      v-if="showImg"
      :imgs="imgs"
      :show="showImg"
      @closeBox="closeImg"
    ></preview-image>

    <!-- 霸屏显示提示 2019.08.08 -->
    <el-dialog
      :visible.sync="full_screenAlert_Show"
      :fullscreen="true"
      :append-to-body="true"
      :show-close="false"
      :center="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="30vh"
      custom-class="_un_pack_full_screen_alert"
    >
      <p v-if="fullScreenAlertText.part_suit">
        {{ fullScreenAlertText.part_suit }}
      </p>
      <div
        class="_special_text_div"
        style="margin-bottom: 5vh"
        v-html="fullScreenAlertText.text"
      />
      <p><i class="el-icon-loading" />{{ fullScreenAlertText.time }}秒后关闭</p>
    </el-dialog>
  </div>
</template>

<script>
import PreviewImage from "../../../components/PreviewImage.vue";
import { partsJudge } from "@/utils/common.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: { PreviewImage },

  props: {
    work_id: {
      type: Number,
      default: 0,
    },

    alert_setting: {
      type: Object,
      default: {},
    },

    is_son_order: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showImg: false,
      imgs: [],
      min: 0,
      resData: {},
      problem: [],
      model: {
        id: 0,
        sub_id: 0,
      },
      parent_porblem_id: "0",
      porblem_id: "0",
      subPorblem: [],
      province: [],
      city: [],
      district: [],
      url: "/erp/Work/getUnPackageData",
      loading: false, // 加载动画是否显示
      work: {},
      form: {
        district: 0,
        city: 0,
        province: 0,
        mobile: "",
        address: "",
        consignee: "",
      },
      init: 0,
      value: "",
      blp_type: [],
      showDialog: true,
      data: [],
      index: "",
      websock: null,
      print_data: null,
      fullscreenLoading: false,
      full_screenAlert_Show: false,
      fullScreenAlertText: {},
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // websocket相关
    initWebSocket() {
      // 初始化weosocket

      const ishttps = document.location.protocol == "https:";
      if (ishttps) {
        var wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        var wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror(e) {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd == "print") {
        if (obj.status == "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "重新打印",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.websocketsend(this.print_data);
          });
        } else {
          this.$message.success("打标成功");
          this.onCloseDialog();
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
    },
    websocketclose(e) {
      // 关闭
    },
    imgClick(imgs) {
      this.showImg = true;
      this.imgs = imgs;
    },
    closeImg() {
      this.showImg = false;
    },
    getCity(id) {
      this.city = [];
      this.district = [];
      this.form.city = 0;
      this.form.district = 0;
      if (!id) {
        return;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Common/getCity", {
          province: id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 200) {
            this.city = res.data.data.list;
          }
        });
    },
    getDistrict(id) {
      this.form.district = 0;
      this.district = [];
      if (!id) {
        return;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Common/getDistrict", {
          city: id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 200) {
            this.district = res.data.data.list;
          }
        });
    },
    inArray(search, array) {
      for (const i in array) {
        if (array[i].blp_type == search) {
          return true;
        }
      }
      return false;
    },
    getBlpText(e) {
      let text = "";
      if (e == 0) {
        return "正常";
      }
      this.blp_type.forEach((v) => {
        if (e == v.key) {
          text = v.label;
        }
      });
      return text;
    },
    submitData() {
      const fun = () => {
        // this.loading = true;
        const arg = {
          work_id: this.work_id,
          detail: this.data,
          form: this.form,
          problem_id: this.model.sub_id,
          back_express_no: this.work.back_shipping_num,
        };
        this.$http.post("/erp/Work/asGoodsCbDabiao", arg).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success("拆包成功，开始打标");
          this.onCloseDialog();
          /* 2018-12-20  */
          this.print_data = JSON.stringify(res.data.data.print_data);
          this.websocketsend(JSON.stringify(res.data.data.print_data));
        });
      };

      // 判断拆包时的拆包数量是否小于待拆包数量 2019.08.06
      let _total = 0;
      for (const v in this.data) {
        _total += Number(this.data[v].num);
      }
      if (_total < this.work.num) {
        this.$confirm(
          "待拆包数量不等于拆包数量，提交后将触发客服工单移交客服跟进，是否确认提交！"
        ).then(fun);
        return;
      }
      fun();
    },
    setIndex(i) {
      this.index = i;
    },

    // 判断填写的数量是否有0, 判断已填写数量是否大于待拆包数量
    jugeNum() {
      let _total = 0;
      for (const v in this.data) {
        if (this.data[v].num == 0)
          return {
            rs: false,
            msg: "已添加的登记类型未填写数量, 不可继续进行添加",
          };
        _total += Number(this.data[v].num);
      }
      if (_total >= this.work.num) {
        return { rs: false, msg: "" };
      }
      return { rs: this.work.num - _total };
    },

    addBlp() {
      if (this.inArray(this.value, this.data)) {
        return this.$message.error("不可添加同样类型的不良品");
      }

      // 判断填写的数量是否有0, 判断已填写数量是否大于待拆包数量
      const juge = this.jugeNum();
      if (!juge.rs) {
        if (juge.msg) {
          return this.$confirm(juge.msg, "操作错误提示", {
            showCancelButton: false,
            closeOnClickModal: false,
          });
        }
        return false;
      }

      this.data.push({
        blp_type: this.value,
        goods_no: this.work.goods_no,
        co_id: this.work.co_id,
        si_id: this.work.si_id,
        num: juge.rs == 1 ? 1 : 0,
        to_where: this.value == 0 ? 4 : 3,
        blp_note: "",
        blp_img: "",
      });
    },

    handleSuccess(e) {
      if (e.code != 200) {
        return this.$message.error("图片上传失败");
      }
      const img = e.data.origin_files[0];
      if (!img) {
        return this.$message.error("图片上传失败");
      }
      this.$set(this.data[this.index], "blp_img", img);
    },
    deleteItem(index) {
      this.data.splice(index, 1);
    },
    fetchData() {
      if (!this.work_id) {
        this.onCloseDialog();
        return this.$message.error("工单ID不存在");
      }
      this.fullscreenLoading = true;
      this.$http
        .post(this.url, {
          work_id: this.work_id,
        })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            this.onCloseDialog();
            return this.$message.error("数据获取失败");
          }
          this.province = result.data.data.province;
          this.$set(this, "work", result.data.data.work);
          const workData = result.data.data.work;
          this.subPorblem = [];
          this.problem = result.data.data.problem;
          this.problem.forEach((item) => {
            if (item.problem_id == workData.parent_id) {
              this.subPorblem = item.children;
            }
          });
          this.model.sub_id = Number(workData.problem_id);
          this.model.id = Number(workData.parent_id);
          this.$set(this, "blp_type", result.data.data.blp_type);
          this.$nextTick(() => {
            this.lockScreenAlert();
          });
        })
        .catch((err) => {
          this.onCloseDialog();
          return this.$message.error("数据获取失败");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
    problemChange(id) {
      this.subPorblem = [];
      this.model.sub_id = 0;
      this.problem.forEach((item) => {
        if (item.problem_id == id) {
          item.children.forEach((v) => {
            this.subPorblem.push(v);
          });
        }
      });
    },

    lockScreenAlert() {
      if (!this.alert_setting.unpack_time) return;
      const _parts = partsJudge(this.work.parts);
      let _suit = "";
      if (this.work.cat_name && this.work.cat_name == "套装") _suit = "套装";
      if (!_parts && !_suit && !this.alert_setting.unpack_text) return; // 没有套装和配件不用管了
      this.$set(
        this.fullScreenAlertText,
        "part_suit",
        [_parts, _suit].filter((v) => v).join("/")
      );
      this.$set(
        this.fullScreenAlertText,
        "text",
        this.alert_setting.unpack_text.replace("\n", "</br>")
      );
      this.$set(
        this.fullScreenAlertText,
        "time",
        Number(this.alert_setting.unpack_time)
      );
      this.full_screenAlert_Show = true;
      const _interval = setInterval(() => {
        this.$set(
          this.fullScreenAlertText,
          "time",
          --this.fullScreenAlertText.time
        );
        if (this.fullScreenAlertText.time <= 0) {
          clearInterval(_interval);
          this.full_screenAlert_Show = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-form-item label {
  width: 150px !important;
}

.el-form-item__content {
  margin-left: 150px !important;
}

.blp-box {
  display: flex;
  flex-direction: row;
}

.blp-text {
  width: 50px;
}

.blp-input {
  width: 130px;
  margin-right: 10px;
}

.blp-note {
  width: 120px;
}

.blp-op {
  margin-left: 10px;
}

.blp-img-up {
  margin-left: 10px;
  width: 40px;
}

.el-icon-picture {
  font-size: 20px;
}

.header-box {
  width: 100%;
  height: 30px;
  padding: 5px;
  font-size: 15px;
  line-height: 30px;
  background-color: rgb(243, 243, 243);
}

.el-dialog__header,
.el-dialog__body {
  padding-top: 0 !important;
  display: none;
}
</style>
<style>
._un_pack_full_screen_alert {
  background-color: rgba(0, 0, 0, 0%);
  border: 0;
  box-shadow: none;
  box-sizing: border-box;
}

._un_pack_full_screen_alert .el-dialog__body {
  margin-top: 10vh;
}

._un_pack_full_screen_alert .el-dialog__body p,
._special_text_div {
  line-height: 60px;
  min-height: 60px;
  font-weight: 800;
  color: #fff;
  font-size: 60px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/components/UnPackage.vue